itsoftApp.createModule("focus-visible", function () {
	itsoftApp.loadScript("assets/scripts/focus-visible/focus-visible.min.js");
});